import { Button } from '@givebutter/primitives/button';
import { faBarcodeRead } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Dialog from 'components/dialog';
import { MobileAppBadges } from 'components/mobile-app-badges';
import MobileAppResponsive from 'images/mobile-app-responsive.webp';

const TicketScanModal = () => {
    return (
        <Dialog.Root>
            <Dialog.Trigger asChild={true}>
                <Button variant="solid">
                    Scan tickets
                    <FontAwesomeIcon icon={faBarcodeRead} />
                </Button>
            </Dialog.Trigger>
            <Dialog.Portal>
                <Dialog.Overlay />
                <Dialog.Content>
                    <div className={'flex flex-col gap-6'}>
                        <div
                            className={
                                'relative h-[215px] rounded-xl bg-[url("images/mobile-gradient.webp")] bg-cover bg-no-repeat'
                            }
                        >
                            <img
                                className={'absolute bottom-0 left-[35%] h-[85%]'}
                                src={MobileAppResponsive}
                                alt={'Givebutter Mobile App'}
                            />
                        </div>
                        <div className={'flex flex-col gap-y-2'}>
                            <p className={'text-xl font-medium'}>
                                Scan Tickets with the Mobile App
                            </p>
                            <p className={'text-sm text-gray-500'}>
                                Download the Givebutter Mobile App and easily scan tickets and
                                check-in attendees, making your event stress free and buttery
                                smooth.
                            </p>
                        </div>
                        <MobileAppBadges className={'!flex-wrap self-center'} />
                        <Dialog.Cancel
                            className={
                                'h-8 w-full whitespace-nowrap rounded-lg border border-gray-300 bg-white py-[0.375rem] pl-3 pr-4 text-sm font-medium text-black hover:bg-gray-100'
                            }
                        >
                            Maybe Later
                        </Dialog.Cancel>
                    </div>
                    <Dialog.Close />
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

export { TicketScanModal };
